export enum PatientReviewsSortOrder {
  MOST_RECENT = 'SORT_OPTIONS.MOST_RECENT',
  HIGHEST_RATING = 'SORT_OPTIONS.HIGHEST',
  LOWEST_RATING = 'SORT_OPTIONS.LOWEST',
}
